<template>
  <sub-page>

    <portal to="admin_support_action">
      <ws-button @click="filters.completed = !filters.completed" outlined :label="!filters.completed ? 'Відкрити виконані' : 'Відкрити поточні'"></ws-button>
    </portal>
    <ws-data-table
        :items="itemsFiltered"
        :headers="headers"
        :row-action="openRequest"
    >
      <template #item.date="{item}">
        <h5 class="wsDARKLIGHT text-no-wrap">{{ MONTH_DAY_TIME(item.date , true  ) }}</h5>
      </template>

      <template #item.manager_group="{item}">
        <h5 class="wsACCENT text-no-wrap">{{ managerGroup[item.manager_group] || '' }}</h5>
      </template>

      <template #item.preview="{item}">
        <div class="d-flex align-center">
          <v-icon :color="wsATTENTION" class="mr-2" v-if="item">mdi-bug</v-icon>
          <h5 class="wsDARKER" :class="[{'font-weight-regular' : item.status !== 0}]">{{ item.preview }}</h5>
        </div>

      </template>

    </ws-data-table>

    <template #dialog>

      <admin-support-sidebar
          v-if="displaySidebar"
          @complete="handleRequestCompletion"
          @update="handleUpdateRequest"
          v-model="displaySidebar"
          :entity="selectedRequest"
          :uuid="selectedRequestUuid"
          :managers-select="managersSelect"
      />

    </template>
  </sub-page>
</template>

<script>
import entitiesFunctions from "@/mixins/entitiesFunctions";
import adminSupportSidebar from "@/components/pages/adminDashboard/support/UI/adminSupportSidebar";
import {mapActions} from "vuex";

export default {
  name: "managerTechSupportReequests",
  components : {
    adminSupportSidebar
  },
  mixins : [entitiesFunctions],
  data() {
    return {
      items : [],
      managerGroup : {
        developers : "Розробники",
        support : "Підтримка",
        sales : "Продажі"
      },
      selectedRequest : {},
      selectedRequestUuid : null,
      displaySidebar : false,
      managersSelect : [],
      filters : {
        completed : false
      }
    }
  },
  computed : {
    itemsFiltered() {
      let items = this.COPY(this.items)

      return items
    },
    headers() {
      let items = [
        { text : 'Дата' , value : "date" , width : 10 },
        { text : 'Запит' , value : "preview" , sortable : false },
        { text : 'Менеджер' , value : "manager_name" , width: 10 },
        { text : 'Відділ' , value : "manager_group" , width: 10 },
        { text : 'Школа' , value : "business_name" , width: 200 }
      ]

      if ( this.filters.completed) {
        items.push(   { text : 'Статус' , value : "resolution" , width: 10 })
      }

      return items

    }
  },
  watch : {
    filters : {
      handler() {
        this.initPage()
      },
      deep : true
    }
  },
  methods : {
    ...mapActions('support' , ["GET_REQUESTS_ADMIN"]),

    async initPage() {
      let result = await this.GET_REQUESTS_ADMIN(this.filters)
      if ( !result ) {
        return this.ERROR
      }
      this.items = result.requests
      this.managersSelect = result.managers_select
    },

    handleUpdateRequest(item) {
      let index = this.items.findIndex(el => el.uuid === item.uuid )
      if ( index === -1 ) {
        return
      }
      this.items[index] = item
      this.items = this.COPY(this.items)
    },
    handleRequestCompletion() {
      let index = this.items.findIndex(el => el.uuid === this.selectedRequestUuid )
      if ( index === -1 ) {
        return
      }
      this.items = this.items.filter(el => el.uuid !== this.selectedRequestUuid )
      this.displaySidebar = false
      this.selectedRequest = {}
      this.selectedRequestUuid = null
    },
    openRequest(item) {
      this.selectedRequestUuid = item.uuid
      this.selectedRequest = this.COPY(item)
      this.displaySidebar = true
    }
  },
  mounted() {
    this.initPage()
  }
}
</script>

<style scoped>

</style>